import { Button, Heading, Separator, Text } from "@nju/ui";

interface IAppointmentDateChangeImpossibleProps {
  onSubmit: () => void;
}

export function AppointmentDateChangeUnavailable({
  onSubmit,
}: IAppointmentDateChangeImpossibleProps) {
  return (
    <>
      <Heading
        align="center"
        className="font-bold mb-3 from-tablet:mb-5"
        font="ttfirs"
        tone="neutral"
        variant="h2"
      >
        zmiana terminu instalacji nie jest możliwa
      </Heading>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <img alt="Informacje o cookies" src="/images/impossible-element.svg" />
      </div>
      <Separator size="s" tone="invisible" />
      <Text
        align="center"
        display="block"
        size={{
          "@fromDesktop": "l",
        }}
      >
        Jeśli chcesz zmienić datę instalacji usługi, zaczekaj na technika i
        poinformuj go o tym.
      </Text>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Button onPress={onSubmit}>ok</Button>
      </div>
    </>
  );
}
